import gql from "graphql-tag";

export default gql`
  query GetDataQualityDecisionUpdates($expected_snapshot_id: String!) {
    getDataQualityDecisionUpdates(expected_snapshot_id: $expected_snapshot_id) {
      tenantId
      objectId
      environment
      revision
      snapshot_id
      decision_evaluation_date
      writes_enabled
      items {
        requirement
        root_cause
        decision {
          environment
          requirement
          root_cause
          version
          decision
          reason
          owner
          actor
          reviewed_at
          review_on
          expires_on
          observed_action {
            requirement
            root_cause
            action_id
            severity
            evidence_fingerprint
            details
            outputs
          }
        }
        state
        review_due
        history {
          before {
            environment
            requirement
            root_cause
            version
            decision
            reason
            owner
            actor
            reviewed_at
            review_on
            expires_on
            observed_action {
              requirement
              root_cause
              action_id
              severity
              evidence_fingerprint
              details
              outputs
            }
          }
          after {
            environment
            requirement
            root_cause
            version
            decision
            reason
            owner
            actor
            reviewed_at
            review_on
            expires_on
            observed_action {
              requirement
              root_cause
              action_id
              severity
              evidence_fingerprint
              details
              outputs
            }
          }
        }
      }
    }
  }
`;
